import {
  ExpertiseState,
  JudgementADDDocumentType,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { get, isEmpty } from 'lodash';
import hash from 'object-hash';
import { VictimType } from 'typings/globalTypes';

export const formattedJudgementAddPronouncing = (
  expertises: ExpertiseState[],
  victims: VictimType[],
  vehicules: Vehicule[],
  judgementAddPronouncing: JudgementADDDocumentType,
  currentDocumentStore?: JudgementADDDocumentType,
) => {
  let FormattedJudgementAddPronouncing = {};
  if (isEmpty(judgementAddPronouncing.convictionId)) {
    FormattedJudgementAddPronouncing = {
      name: judgementAddPronouncing.name,
      url: judgementAddPronouncing.url,
      type: judgementAddPronouncing.type,
      judgementDate: judgementAddPronouncing.judgementDate,
      responsibilityShare: judgementAddPronouncing.responsibilityShare,
      expertises: judgementAddPronouncing.expertises,
      id: judgementAddPronouncing.id,
      status: judgementAddPronouncing.status,
      rejectionReason: judgementAddPronouncing.rejectionReason,
      uploadedBy: judgementAddPronouncing.uploadedBy,
      validator: judgementAddPronouncing.validator,
      createdAt: judgementAddPronouncing.createdAt,
    } as any;
  } else {
    FormattedJudgementAddPronouncing = {
      ...judgementAddPronouncing,
    } as JudgementADDDocumentType;
  }
  const formattedExpertises = [...expertises].map(exp => {
    return {
      expertiseId: exp.expertiseId,
      expertiseJudgementAddDocumentId: exp.expertiseJudgementAddDocumentId,
      victims: victims
        .map((vic: any) => {
          const { expertiseJudgementAddVictims, ...rest } = vic;
          return {
            ...rest,
            expertise: [...exp.expertises].find(
              (victimExpertise: any) => vic.id === victimExpertise.victimId,
            ),
          };
        })
        .filter((vic: any) => !!get(vic, 'expertise'))
        .filter(vehicule => [...exp.victims].includes(Number(vehicule.id))),
      vehicules: vehicules
        .map(vehicule => {
          const { expertiseJudgementAddVehicules, ...rest } = vehicule;

          return {
            ...rest,
            expertise: [...exp.expertises].find(
              (vehicleExpertise: any) =>
                vehicule.id === vehicleExpertise.vehiculeId,
            ),
          };
        })
        .filter((vehicule: any) => !!get(vehicule, 'expertise'))
        .filter(vehicule => [...exp.vehicules].includes(Number(vehicule.id))),
    };
  });

  return {
    ...(FormattedJudgementAddPronouncing as JudgementADDDocumentType),
    ...(currentDocumentStore
      ? {
          isUpdated:
            hash({
              ...FormattedJudgementAddPronouncing,
              expertises: formattedExpertises,
            }) !== hash(currentDocumentStore),
        }
      : undefined),
    expertises: formattedExpertises,
  };
};
